export const Columns = {
    1: "grid grid-cols-1 gap-5",
    2: "grid grid-cols-2 gap-5",
    3: "grid grid-cols-3 gap-5",
    4: "grid grid-cols-4 gap-5",
    5: "grid grid-cols-5 gap-5",
    6: "grid grid-cols-6 gap-5"
};
